import { updateDoc, doc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../firebaseConfig";

const inputCls =
  "rounded-lg border border-slate-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 outline-none px-3 py-2 text-sm w-full transition-colors";
const labelCls = "text-sm font-medium text-slate-600";
const sectionLabelCls =
  "text-xs font-semibold text-slate-400 uppercase tracking-wide";

function DepartmentEdit(props) {
  const data = props.data;
  const [bachelor, setBachelor] = useState(data.bachelor);
  const [degree, setDegree] = useState(data.degree);
  const [name, setName] = useState(data.name);
  const [idOffice, setIdOffice] = useState(data.idOffice);
  const [shortDesc, setShortDesc] = useState(data.shortDesc);
  const [longDesc, setLongDesc] = useState(data.longDesc);

  // Build initial paths array from p1–p10, filtering out empty/undefined values
  const initialPaths = [
    data.p1, data.p2, data.p3, data.p4, data.p5,
    data.p6, data.p7, data.p8, data.p9, data.p10,
  ].filter((p) => p && p.trim() !== "");
  const [paths, setPaths] = useState(initialPaths.length > 0 ? initialPaths : [""]);

  const updatePath = (index, value) => {
    const updated = [...paths];
    updated[index] = value;
    setPaths(updated);
  };

  const addPath = () => {
    if (paths.length < 10) setPaths([...paths, ""]);
  };

  const removePath = (index) => {
    if (paths.length === 1) return;
    setPaths(paths.filter((_, i) => i !== index));
  };

  const editDepartment = async () => {
    const pathsObj = {};
    for (let i = 0; i < 10; i++) pathsObj[`p${i + 1}`] = paths[i] || "";

    const programsDoc = doc(db, "programs", data.id);
    await updateDoc(programsDoc, {
      bachelor,
      degree,
      name,
      idOffice: parseInt(idOffice),
      shortDesc,
      longDesc,
      ...pathsObj,
      url: name.replace(/ /g, "-").toLowerCase(),
    });
    alert("Department Updated");
    props.close();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-slate-800 opacity-50" onClick={props.close} />
      <div className="relative z-10 w-full max-w-2xl mx-4 bg-white rounded-2xl shadow-2xl overflow-y-auto max-h-[90vh]">

        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-slate-100">
          <div>
            <h2 className="text-xl font-bold text-slate-800">Edit Department</h2>
            <p className="text-sm text-slate-400 mt-0.5">Update degree program details</p>
          </div>
          <button
            className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={props.close}
            aria-label="Close"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 flex flex-col gap-6">

          {/* Section: Program Info */}
          <div className="flex flex-col gap-4">
            <p className={sectionLabelCls}>Program Info</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <label className={labelCls} htmlFor="de-bachelor">Degree</label>
                <input
                  id="de-bachelor"
                  className={inputCls}
                  type="text"
                  placeholder="Bachelor of Science"
                  value={bachelor}
                  onChange={(e) => setBachelor(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className={labelCls} htmlFor="de-degree">Course</label>
                <input
                  id="de-degree"
                  className={inputCls}
                  type="text"
                  placeholder="Civil Engineering"
                  value={degree}
                  onChange={(e) => setDegree(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-1 sm:col-span-2">
                <label className={labelCls} htmlFor="de-name">Full Course Name</label>
                <input
                  id="de-name"
                  className={inputCls}
                  type="text"
                  placeholder="BS Civil Engineering"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-1 sm:col-span-2">
                <label className={labelCls} htmlFor="de-office">Office / College</label>
                <select
                  id="de-office"
                  className={inputCls}
                  value={idOffice}
                  onChange={(e) => setIdOffice(e.target.value)}
                >
                  {props.offices.map((val, key) => (
                    <option key={key} value={val.idOffice}>{val.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Section: Description */}
          <div className="flex flex-col gap-4 border-t border-slate-100 pt-5">
            <p className={sectionLabelCls}>Description</p>
            <div className="flex flex-col gap-1">
              <label className={labelCls} htmlFor="de-short">Short Description</label>
              <textarea
                id="de-short"
                className={inputCls}
                rows={3}
                placeholder="This will be displayed on the programs pages"
                value={shortDesc}
                onChange={(e) => setShortDesc(e.target.value)}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className={labelCls} htmlFor="de-long">Long Description</label>
              <textarea
                id="de-long"
                className={inputCls}
                rows={4}
                placeholder="This will be displayed on the page of the respective program"
                value={longDesc}
                onChange={(e) => setLongDesc(e.target.value)}
              />
            </div>
          </div>

          {/* Section: Career Paths */}
          <div className="flex flex-col gap-4 border-t border-slate-100 pt-5">
            <div className="flex items-center justify-between">
              <p className={sectionLabelCls}>Career Paths</p>
              <span className="text-xs text-slate-400">{paths.length}/10</span>
            </div>
            <div className="flex flex-col gap-2">
              {paths.map((path, index) => (
                <div key={index} className="flex items-center gap-2">
                  <input
                    className={inputCls}
                    type="text"
                    placeholder={`Career path ${index + 1}`}
                    value={path}
                    onChange={(e) => updatePath(index, e.target.value)}
                  />
                  {paths.length > 1 && (
                    <button
                      type="button"
                      className="flex-shrink-0 p-1.5 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 transition-colors"
                      onClick={() => removePath(index)}
                      aria-label="Remove path"
                    >
                      <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              ))}
            </div>
            {paths.length < 10 && (
              <button
                type="button"
                className="self-start flex items-center gap-1.5 text-sm font-medium text-sky-600 hover:text-sky-700 transition-colors"
                onClick={addPath}
              >
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add path
              </button>
            )}
          </div>

        </div>

        {/* Footer */}
        <div className="flex gap-3 px-6 py-4 border-t border-slate-100">
          <button
            type="button"
            className="flex-1 py-2 rounded-lg border border-slate-300 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-colors"
            onClick={props.close}
          >
            Cancel
          </button>
          <button
            type="button"
            className="flex-1 py-2 rounded-lg bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white text-sm font-semibold transition-colors shadow-sm"
            onClick={editDepartment}
          >
            Update Department
          </button>
        </div>

      </div>
    </div>
  );
}

export default DepartmentEdit;
